import api from "@/plugins/api/EntryPoint";

export default {
  // Старый метод, который вы просили оставить
  async getIndications(params, callBackFn) {
    await api.post(`history/indication`, params, callBackFn);
  },

  // Новый метод для получения истории показаний
  async getAllReadings(ls, credentials, callBackFn, sessionId = null) {
    let requestBody;
    const store = require("@/store").default;
    const resetSessionAndRetry = async () => {
      store.commit("Auth/SET_SESSION_ID", null);
      requestBody = {
        account_id: ls,
        username: credentials.username,
        password: credentials.password,
      };
      await api.post(`readings`, requestBody, callBackFn, false, true);
    };
    if (sessionId) {
      requestBody = {
        account_id: ls,
        session_id: sessionId,
      }; // username/password не добавляем вообще
      await api
        .post(
          `readings`,
          requestBody,
          async (response) => {
            if (
              response &&
              response.detail &&
              response.detail.includes("Сессия недействительна")
            ) {
              await resetSessionAndRetry();
            } else {
              callBackFn(response);
            }
          },
          false,
          true
        )
        .catch(async (error) => {
          if (
            (error &&
              error.response &&
              error.response.status === 401 &&
              error.response.data &&
              error.response.data.detail &&
              error.response.data.detail.includes("Сессия недействительна")) ||
            (error && error.response && error.response.status === 500)
          ) {
            console.log(
              "Перехвачена ошибка сессии (401 или 500) в IndicationsHistory, попытка переавторизации..."
            );
            await resetSessionAndRetry();
          } else {
            throw error;
          }
        });
    } else {
      requestBody = {
        account_id: ls,
        username: credentials.username,
        password: credentials.password,
      };
      await api.post(`readings`, requestBody, callBackFn, false, true);
    }
  },
};
